import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router'

const routes: Array<RouteRecordRaw> = [

  {
    path: '/informative',
    name: 'INFORMATIVE',
    component: () => import(/* webpackChunkName: "about" */ '@/views/informative/index.vue'),
  },

  {
    path: '/informative/:id',
    name: 'informativa',
    component: () => import(/* webpackChunkName: "about" */ '@/views/informative/editInformativa.vue'),
  },
  {
    path: '/soggetti',
    name: 'soggetti',
    component: () => import(/* webpackChunkName: "about" */ '@/views/approvazioni/index.vue'),
  },
  {
    path: '/forms',
    name: 'forms',
    component: () => import(/* webpackChunkName: "about" */ '@/views/forms/index.vue'),
  },
  {
    path: '/pending',
    name: 'In attesa',
    component: () => import(/* webpackChunkName: "about" */ '@/views/approvazioni/Pending.vue'),
  },
  {
    path: '/forms/:id',
    name: 'Modifica modulo',
    component: () => import(/* webpackChunkName: "about" */ '@/views/forms/edit.vue'),
  },
  {
    path: '/dati-aziendali',
    name: 'Brand',
    component: () => import(/* webpackChunkName: "about" */ '@/views/brand.vue'),
  },
  {
    path: '/comunicazioni',
    name: 'comunicazioni',
    component: () => import(/* webpackChunkName: "about" */ '@/views/comunicazioni/index.vue'),
  },
  {
    path: '/comunicazione/:id',
    name: 'comunicazione',
    component: () => import(/* webpackChunkName: "about" */ '@/views/comunicazioni/editComunicazione.vue'),
  },
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Dashboard.vue'),
  },
  {
    path: '/user/:id',
    name: 'Utente',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Utente.vue'),
  },
  {
    path: '/Utente/:id',
    name: 'utente',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Utente.vue'),
  },
  {
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Utenti.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '@/views/auth/Login.vue'),
  },

  {
    path: '/resetPwd/:jwt',
    name: 'resetPwd',
    component: () => import(/* webpackChunkName: "about" */ '@/views/auth/resetPwd.vue'),
  },
  {
    path: '/registrazione/:jwt',
    name: 'registrazione',
    component: () => import(/* webpackChunkName: "about" */ '@/views/auth/reg.vue'),
  },
  {
    path: '/optin/:jwt',
    name: 'optin',
    component: () => import(/* webpackChunkName: "about" */ '@/views/auth/optin.vue'),
  },
  {
    path: '/devices',
    name: 'devices',
    component: () => import(/* webpackChunkName: "about" */ '@/views/devices.vue'),
  },
  {
    path: '/device',
    name: 'device',
    component: () => import(/* webpackChunkName: "about" */ '@/views/device.vue'),
  },
  {
    path: '/archivio',
    name: 'archivio',
    component: () => import(/* webpackChunkName: "about" */ '@/views/archivio.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Dashboard.vue'),
  },
  {
    path: '/Comunicazioni',
    name: 'Comunicazioni',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Segnalazioni.vue'),
  },
  {
    path: '/segnalazione/:id',
    name: 'segnalazione',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Segnalazione.vue'),
  },
  {
    path: '/account',
    name: 'account',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Account.vue'),
  },
  {
    path: '/impostazioni',
    name: 'impostazioni',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Impostazioni.vue'),
  }, {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import(/* webpackChunkName: "about" */ '@/views/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
